module.exports = __webpack_public_path__ + "static/media/Kessel105-Book.d23c9e8f.woff2";